import React from 'react'
import { Sidebar, FormFuelCredit, FuelCreditPlaceholder, HowToUse } from './'
import PropTypes from 'prop-types'
import { Alert } from 'loyal-react'
import ModalServices from '../Services/ModalServices/ModalServices'
import '@loyal_template/services.css'

import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

const showError = (error, handleCloseError) =>
  error.hasError ? (
    <Alert
      isError
      title={error.title}
      description={error.description}
      className='pb-2'
      onClose={() => handleCloseError()}
    />
  ) : (
    ''
  )

const FuelCredit = ({
  isloading,
  handleCloseError,
  errorField,
  closeterms,
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent,
  sendRedemptionError,
  sendRedemption,
  packages,
  handlerChangePackage,
  packageSelected,
  currencyConfiguration,
  shellSupplierId,
  regulationType,
  showModal,
  handlerFormatValue,
  handlerFinalizePayment,
  loadingPayment,
  errorPage
}) => (
  <ReactPlaceholder
    ready
    customPlaceholder={<FuelCreditPlaceholder />}
  >
    <div className='container-fluid px-0 px-md-1 pt-0'>
      <div className='container pt-0 pb-3 py-md-5'>
        <div className='row pt-0 pt-md-0'>
          {showError(errorPage, handleCloseError)}
          <div className='col-12 col-md-8 pl-0 pl-md-1 pr-0 pr-md-2 '>
            <div className='row mx-0'>
              <div className='col-12 radius border border-color-ui-3'>
                <div className='row'>
                  <div className='col-12'>
                    <div className='bg-servicos-shell radius-top row align-items-center px-1'>
                      <div className='col-12 px-3'>
                        <h2 className='color-ui-white txt-title-2 txt-circular-book'>
                          Shell Box
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row radius-bottom bg-white px-1'>
                  <div className='col-12 px-2 py-2'>
                    <p className='txt-body-sm'>
                      Abasteça o seu veículo com pontos. Escolha o valor em
                      créditos que deseja utilizar.
                    </p>
                  </div>
                  <div className='col-12 px-3'>
                    <FormFuelCredit
                      errorField={errorField}
                      isloading={isloading}
                      packages={packages}
                      handlerChangePackage={handlerChangePackage}
                      packageSelected={packageSelected}
                      currencyConfiguration={currencyConfiguration}
                      handlerFormatValue={handlerFormatValue}
                    />
                  </div>

                </div>
              </div>
              { process.env.REACT_APP_FUELCREDIT_HOWTOUSE && <HowToUse /> }
            </div>
          </div>
          <ModalServices
            title={'Termos do Regulamento de Shell Box'}
            show={showModal}
            onClose={closeterms}
            acceptTerms={e => acceptTermsEvent(true)}
            terms={{
              vendorId: shellSupplierId,
              type: regulationType
            }}
            isLoading={sendRedemption}
          />
          <Sidebar
            showTermsEvent={showTermsEvent}
            acceptTermsEvent={acceptTermsEvent}
            acceptTerms={acceptTerms}
            handlerFinalizePayment={handlerFinalizePayment}
            packageSelected={packageSelected}
            handlerFormatValue={handlerFormatValue}
            currencyConfiguration={currencyConfiguration}
            pointsValue={packageSelected.pointsQuantity || 0}
            creditValue={packageSelected.description || '0'}
            creditName={'Shell Box'}
            loadingPayment={sendRedemption}
          />
        </div>
      </div>
    </div>
  </ReactPlaceholder>
)

FuelCredit.propTypes = {
  isloading: PropTypes.bool,
  handleCloseError: PropTypes.func,
  errorField: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  closeterms: PropTypes.func,
  acceptTerms: PropTypes.bool,
  acceptTermsEvent: PropTypes.func,
  sendRedemptionError: PropTypes.bool,
  sendRedemption: PropTypes.bool,
  packages: PropTypes.array,
  handlerChangePackage: PropTypes.func,
  packageSelected: PropTypes.object,
  currencyConfiguration: PropTypes.object,
  shellSupplierId: PropTypes.number,
  regulationType: PropTypes.string,
  showModal: PropTypes.bool,
  handlerFormatValue: PropTypes.func,
  handlerFinalizePayment: PropTypes.func,
  loadingPayment: PropTypes.bool,
  errorPage: PropTypes.object
}

export default FuelCredit



// WEBPACK FOOTER //
// ./src/features/FuelCredit/FuelCredit.js